<template>
  <el-dialog
    :title="isEdit ? '编辑字典数据' : '新增字典数据'"
    :visible.sync="visible"
    width="520px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="formRules" label-width="110px">
      <el-form-item label="字典类型">
        <el-input :value="form.dictType" disabled />
      </el-form-item>
      <el-form-item label="字典标签" prop="dictLabel">
        <el-input v-model="form.dictLabel" placeholder="业务展示文字，如：维修工具" maxlength="100" />
      </el-form-item>
      <el-form-item label="字典键值" prop="dictValue">
        <el-input
          v-model="form.dictValue"
          placeholder="存入数据库的值，如：1 或 maintain"
          maxlength="100"
          :disabled="isEdit"
        />
        <div v-if="isEdit" class="field-tip">字典键值为业务契约键，创建后不可修改</div>
      </el-form-item>
      <el-form-item label="排序号" prop="dictSort">
        <el-input-number v-model="form.dictSort" :min="0" :max="9999" style="width: 140px" />
      </el-form-item>
      <el-form-item label="样式属性">
        <el-select v-model="form.listClass" placeholder="用于 el-tag 的 type 属性" clearable style="width: 100%">
          <el-option label="默认 (default)" value="" />
          <el-option label="主色 (primary)" value="primary" />
          <el-option label="成功 (success)" value="success" />
          <el-option label="警告 (warning)" value="warning" />
          <el-option label="危险 (danger)" value="danger" />
          <el-option label="信息 (info)" value="info" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="0">正常</el-radio>
          <el-radio label="1">停用</el-radio>
        </el-radio-group>
        <div v-if="form.status === '1'" class="field-tip">
          停用后该项不会出现在业务选项中。
        </div>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button :disabled="saving" @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="saving" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { dictService } from './dict.service';
import { clearDictCache } from '@/features/components/dict/dict.api';

export default {
  name: 'DictDataDialog',

  data() {
    return {
      visible: false,
      saving: false,
      isEdit: false,
      form: {
        dictCode: null,
        dictType: '',
        dictLabel: '',
        dictValue: '',
        dictSort: 0,
        listClass: '',
        status: '0',
        remark: ''
      },
    };
  },

  computed: {
    formRules() {
      const rules = {
        dictLabel: [{ required: true, message: '请输入字典标签', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      };
      if (!this.isEdit) {
        rules.dictValue = [{ required: true, message: '请输入字典键值', trigger: 'blur' }];
      }
      return rules;
    }
  },

  methods: {
    open(dictType, row) {
      this.isEdit = !!row;
      if (row) {
        this.form = {
          dictCode: row.dictCode,
          dictType: row.dictType,
          dictLabel: row.dictLabel,
          dictValue: row.dictValue,
          dictSort: row.dictSort || 0,
          listClass: row.listClass || '',
          status: row.status || '0',
          remark: row.remark || ''
        };
      } else {
        this.form = {
          dictCode: null,
          dictType,
          dictLabel: '',
          dictValue: '',
          dictSort: 0,
          listClass: '',
          status: '0',
          remark: ''
        };
      }
      this.visible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        const req = this.isEdit 
          ? dictService.updateData(this.form) 
          : dictService.saveData(this.form);
        
        req.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
          clearDictCache(this.form.dictType);
          this.visible = false;
          this.$emit('saved');
        }).finally(() => {
          this.saving = false;
        });
      });
    },

    handleClose() {
      this.$refs.form && this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped>
.field-tip {
  font-size: 12px;
  line-height: 1.5;
  color: #e6a23c;
  margin-top: 4px;
}
</style>
